<template>
    <span :style="style">
        {{ rendered }}
    </span>
</template>

<script>
export default {
  props: {'value': {}, threshold: {default: 0}, format: {default: () => value => value}},

  computed: {
    style() {
      return {'color': this.color}
    },

    color() {
      if (this.value === null) {
        return 'inherit'
      }

      return this.value >= this.threshold ? '#62d26f' : '#e8384f'
    },

    rendered() {
      return this.value === null ? 'N/A' : this.format(Math.round(this.value))
    }
  }
}
</script>
